import { IButtonsConfig } from './typings';

const config: IButtonsConfig = {
  title: '',
  icon: undefined,
  buttons: [],
};

export default config;
